export const assessmentMessages = {
  ASSESSMENT_ATTEMPT_INPUT_INVALID: '답안 또는 채점 입력을 확인해 주세요. 화면을 다시 열어 최신 내용을 확인해 주세요.',
  ASSESSMENT_ATTEMPT_NOT_FOUND: '응시 내역을 찾을 수 없습니다.',
  ASSESSMENT_ATTEMPT_FINISHED: '이미 종료된 응시입니다. 현재 결과를 다시 확인해 주세요.',
  ASSESSMENT_ATTEMPT_LIMIT: '허용된 응시 횟수를 모두 사용했습니다.',
  ASSESSMENT_GRADING_PENDING: '이전 응시의 채점이 끝난 뒤 다시 응시할 수 있습니다.',
  ASSESSMENT_REQUEST_CONFLICT: '요청 내용이 이전 요청과 다릅니다. 화면을 다시 열어 최신 내용을 확인해 주세요.',
  ASSESSMENT_VERSION_CONFLICT: '다른 창에서 답안 또는 채점이 변경되었습니다. 화면을 다시 열어 최신 내용을 확인해 주세요.',
  ASSESSMENT_NOT_SUBMITTED: '제출이 완료된 응시만 채점할 수 있습니다.',
  ASSESSMENT_WINDOW_UNAVAILABLE: '현재 시험 기간이 아니거나 시험이 중지되어 있습니다.',
  ASSESSMENT_PROGRESS_REQUIRED: '응시에 필요한 인정 진도에 도달하지 않았습니다.',
  ASSESSMENT_IDENTITY_TARGET_DENIED: '이 응시의 본인인증 대상을 확인할 수 없습니다.',
}
